<template>
  <section class="hero">
    <div class="hero--box">
      <h2>Why Go Premium You May Ask?</h2>
      <div class="hero--reasons">
        <div class="hero--reasons--reason">
          <div class="hero--reasons--reason--image">
            <svg
              width="77"
              height="78"
              viewBox="0 0 77 78"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 24.64C0 3.08 3.08 0 24.64 0H52.36C73.92 0 77 3.08 77 24.64V52.36C77 73.92 73.92 77 52.36 77H24.64C3.08 77 0 73.92 0 52.36V24.64Z"
                fill="#8F3D55"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M38.9875 20.2249C36.1614 20.2249 33.8704 22.5159 33.8704 25.342C33.8704 28.168 36.1614 30.459 38.9875 30.459C41.8136 30.459 44.1046 28.168 44.1046 25.342C44.1046 22.5159 41.8136 20.2249 38.9875 20.2249ZM30.459 25.342C30.459 20.6318 34.2773 16.8135 38.9875 16.8135C43.6976 16.8135 47.5159 20.6318 47.5159 25.342C47.5159 30.0521 43.6976 33.8704 38.9875 33.8704C34.2773 33.8704 30.459 30.0521 30.459 25.342Z"
                fill="white"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M36.6282 40.8758L38.9878 42.7697L41.3474 40.8758C40.6153 40.7572 39.8303 40.6926 38.9878 40.6926C38.1452 40.6926 37.3602 40.7572 36.6282 40.8758ZM45.1798 42.1741L41.1914 45.3753L43.8801 50.0806C44.2617 50.7484 44.1492 51.589 43.6053 52.1329L40.1939 55.5443C39.5278 56.2104 38.4478 56.2104 37.7817 55.5443L34.3703 52.1329C33.8264 51.589 33.7138 50.7484 34.0954 50.0806L36.7841 45.3753L32.7958 42.1741C29.7918 43.8259 27.9429 46.6331 26.8189 49.2685C26.2084 50.7 25.8333 52.0331 25.6116 53.0074C25.5011 53.493 25.4298 53.8851 25.3866 54.1503C25.3651 54.2828 25.3507 54.3832 25.342 54.4474C25.3376 54.4795 25.3347 54.5025 25.3331 54.5159L25.3318 54.5266C25.2272 55.4623 24.3841 56.1375 23.4481 56.0335C22.5119 55.9294 21.8372 55.0861 21.9412 54.1498L23.6365 54.3382C21.9412 54.1498 21.9412 54.1505 21.9412 54.1498L21.9416 54.1469L21.942 54.1431L21.9432 54.1324L21.9472 54.0996C21.9505 54.0727 21.9552 54.0359 21.9615 53.9896C21.974 53.8971 21.9928 53.7667 22.0195 53.6029C22.0727 53.2755 22.1573 52.8131 22.2852 52.2507C22.5404 51.1291 22.9719 49.5928 23.681 47.9302C25.0873 44.6329 27.6729 40.6439 32.3336 38.6027C34.2389 37.7682 36.4465 37.2812 38.9878 37.2812C41.5291 37.2812 43.7366 37.7682 45.642 38.6027C50.3027 40.6439 52.8882 44.6329 54.2945 47.9302C55.0036 49.5928 55.4352 51.1291 55.6903 52.2507C55.8183 52.8131 55.9029 53.2755 55.9561 53.6029C55.9827 53.7667 56.0016 53.8971 56.0141 53.9896C56.0204 54.0359 56.0251 54.0727 56.0284 54.0996L56.0323 54.1324L56.0335 54.1431L56.034 54.1469C56.034 54.1476 56.0343 54.1498 54.339 54.3382L56.0343 54.1498C56.1383 55.0861 55.4637 55.9294 54.5274 56.0335C53.592 56.1374 52.7494 55.4641 52.6441 54.5293L52.6438 54.5266L52.6425 54.5159C52.6408 54.5025 52.6379 54.4795 52.6336 54.4474C52.6249 54.3832 52.6104 54.2828 52.5889 54.1503C52.5458 53.8851 52.4744 53.493 52.364 53.0074C52.1423 52.0331 51.7671 50.7 51.1566 49.2685C50.0326 46.6331 48.1838 43.8259 45.1798 42.1741ZM38.9878 48.3948L37.7037 50.6419L38.9878 51.926L40.2718 50.6419L38.9878 48.3948Z"
                fill="white"
              />
            </svg>
          </div>
          <div class="hero--reasons--reason--text">
            <h5>You get a mentor.</h5>
            <p>
              Unlimited access to on-demand mentors to schedule as many calls as
              you like with our ‘on-demand’ design mentors who can provide
              additional feedback & insights.
            </p>
          </div>
        </div>
        <div class="hero--reasons--reason">
          <div class="hero--reasons--reason--image">
            <svg
              width="78"
              height="79"
              viewBox="0 0 78 79"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.0512695 25.5992C0.0512695 4.01253 3.13509 0.928711 24.7218 0.928711H52.4761C74.0628 0.928711 77.1467 4.01253 77.1467 25.5992V53.3536C77.1467 74.9403 74.0628 78.0241 52.4761 78.0241H24.7218C3.13509 78.0241 0.0512695 74.9403 0.0512695 53.3536V25.5992Z"
                fill="#8F3D55"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M28.8398 21.1795C28.8398 20.2363 29.6045 19.4717 30.5477 19.4717H47.6257C48.5689 19.4717 49.3336 20.2363 49.3336 21.1795V28.0107C49.3336 28.9539 48.5689 29.7185 47.6257 29.7185H30.5477C29.6045 29.7185 28.8398 28.9539 28.8398 28.0107V21.1795ZM32.2555 22.8873V26.3029H45.9179V22.8873H32.2555Z"
                fill="white"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15.1777 28.0105C15.1777 27.0673 15.9423 26.3027 16.8855 26.3027H61.2886C62.2318 26.3027 62.9964 27.0673 62.9964 28.0105V58.7511C62.9964 59.6943 62.2318 60.4589 61.2886 60.4589H16.8855C15.9423 60.4589 15.1777 59.6943 15.1777 58.7511V28.0105ZM18.5934 29.7184V57.0433H59.5808V29.7184H18.5934Z"
                fill="white"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15.1777 28.0105C15.1777 27.0673 15.9423 26.3027 16.8855 26.3027H61.2886C62.2318 26.3027 62.9964 27.0673 62.9964 28.0105V39.9652C62.9964 40.7793 62.4218 41.4802 61.6235 41.6399L44.5454 45.0555C43.6205 45.2404 42.7208 44.6406 42.5359 43.7158C42.3509 42.7909 42.9507 41.8912 43.8756 41.7062L59.5808 38.5651V29.7184H18.5934V38.5651L34.2986 41.7062C35.2234 41.8912 35.8233 42.7909 35.6383 43.7158C35.4533 44.6406 34.5536 45.2404 33.6287 45.0555L16.5506 41.6399C15.7523 41.4802 15.1777 40.7793 15.1777 39.9652V28.0105Z"
                fill="white"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M33.9639 39.9656C33.9639 39.0224 34.7285 38.2578 35.6717 38.2578H42.5029C43.4461 38.2578 44.2107 39.0224 44.2107 39.9656V46.7969C44.2107 47.7401 43.4461 48.5047 42.5029 48.5047H35.6717C34.7285 48.5047 33.9639 47.7401 33.9639 46.7969V39.9656ZM37.3795 41.6734V45.089H40.7951V41.6734H37.3795Z"
                fill="white"
              />
            </svg>
          </div>
          <div class="hero--reasons--reason--text">
            <h5>Connect with jobs.</h5>
            <p>
              Unlimited access to on-demand mentors to schedule as many calls as
              you like with our ‘on-demand’ design mentors who can provide
              additional feedback & insights.
            </p>
          </div>
        </div>
        <div class="hero--reasons--reason">
          <div class="hero--reasons--reason--image">
            <svg
              width="78"
              height="79"
              viewBox="0 0 78 79"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.956543 25.5826C0.956543 4.01045 4.03828 0.928711 25.6104 0.928711H53.3461C74.9183 0.928711 78 4.01045 78 25.5826V53.3183C78 74.8904 74.9183 77.9722 53.3461 77.9722H25.6104C4.03828 77.9722 0.956543 74.8904 0.956543 53.3183V25.5826Z"
                fill="#8F3D55"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M50.5196 36.7363C51.2269 36.7372 51.8603 37.1741 52.1123 37.8349C52.1779 38.0069 52.232 38.1846 52.2746 38.3672L52.2746 38.3672C52.3468 38.6766 52.7016 38.8235 52.9714 38.6558C56.4554 36.49 60.477 40.5116 58.3112 43.9957C58.1435 44.2654 58.2904 44.6202 58.5998 44.6924C62.5948 45.6245 62.5948 51.3119 58.5998 52.244C58.2904 52.3162 58.1435 52.671 58.3112 52.9408C60.477 56.4248 56.4554 60.4464 52.9714 58.2806C52.7016 58.1129 52.3468 58.2598 52.2746 58.5692C51.3425 62.5642 45.6551 62.5642 44.723 58.5692C44.6508 58.2598 44.296 58.1129 44.0262 58.2806C40.5422 60.4464 36.5206 56.4248 38.6864 52.9408C38.8541 52.671 38.7072 52.3162 38.3978 52.244C38.3978 52.244 38.3978 52.244 38.3978 52.244M50.5196 36.7363C49.8124 36.7355 49.1779 37.171 48.9244 37.8312L50.5196 36.7363ZM48.9244 37.8312C48.8088 38.1321 48.5719 38.3927 48.1149 38.4993L48.9244 37.8312ZM50.2713 41.2651C49.8643 41.5124 49.4029 41.7038 48.8904 41.8233C48.192 41.9863 47.8262 42.728 48.0759 43.3655C48.2155 43.3541 48.3566 43.3482 48.4988 43.3482C51.3265 43.3482 53.6188 45.6405 53.6188 48.4682C53.6188 51.2959 51.3265 53.5882 48.4988 53.5882C46.404 53.5882 44.6038 52.3308 43.8107 50.529C43.1606 50.456 42.5048 50.2359 41.8812 49.8483L42.5938 48.7019L41.8812 49.8483C41.546 49.6399 41.1582 49.6267 40.8315 49.7614C42.2072 50.9545 42.6382 53.049 41.5852 54.7428C41.4959 54.8866 41.4948 54.9826 41.5043 55.0453C41.5166 55.1261 41.5618 55.2264 41.6512 55.3158C41.7406 55.4052 41.8409 55.4504 41.9217 55.4627C41.9844 55.4722 42.0804 55.4711 42.2242 55.3818C44.479 53.9801 47.4438 55.2081 48.047 57.7936C48.0855 57.9585 48.1526 58.0272 48.2036 58.0647C48.2695 58.1132 48.3724 58.1522 48.4988 58.1522C48.6252 58.1522 48.7281 58.1132 48.794 58.0647C48.845 58.0272 48.9121 57.9585 48.9506 57.7936C49.5538 55.2081 52.5186 53.9801 54.7734 55.3818C54.9172 55.4711 55.0132 55.4722 55.0758 55.4627C55.1567 55.4504 55.257 55.4052 55.3464 55.3158C55.4358 55.2264 55.481 55.1261 55.4933 55.0453C55.5028 54.9826 55.5017 54.8866 55.4123 54.7428C54.0107 52.488 55.2387 49.5232 57.8242 48.92C57.9891 48.8815 58.0578 48.8144 58.0953 48.7634C58.1438 48.6975 58.1828 48.5946 58.1828 48.4682C58.1828 48.3418 58.1438 48.2389 58.0953 48.173C58.0578 48.122 57.9891 48.0549 57.8242 48.0164C55.2387 47.4132 54.0107 44.4484 55.4123 42.1936C55.5017 42.0498 55.5028 41.9538 55.4933 41.8912C55.481 41.8103 55.4358 41.71 55.3464 41.6206C55.257 41.5312 55.1567 41.486 55.0758 41.4737C55.0132 41.4642 54.9172 41.4653 54.7734 41.5547C53.2882 42.478 51.4948 42.2602 50.2713 41.2651ZM48.1149 38.4993C45.0688 39.21 43.622 42.7029 45.2734 45.3593L48.1149 38.4993ZM48.4988 46.7615C48.2466 46.7615 48.0114 46.8152 47.8004 46.9101C47.336 47.1189 46.8026 47.1094 46.3458 46.8842C45.8891 46.659 45.5568 46.2416 45.4397 45.746C45.413 45.6332 45.3629 45.5033 45.2734 45.3593M48.4988 46.7615C49.4414 46.7615 50.2055 47.5256 50.2055 48.4682L48.4988 46.7615ZM36.8232 49.7909C37.5339 46.7449 41.0268 45.2981 43.6833 46.9494C44.0369 47.1693 44.3433 47.1757 44.598 47.0981C45.0935 46.9471 45.6308 47.0293 46.0585 47.3217C46.4861 47.614 46.7579 48.0847 46.7972 48.6012C46.864 49.4808 47.6012 50.1749 48.4988 50.1749C49.4414 50.1749 50.2055 49.4108 50.2055 48.4682M36.8232 49.7909L38.1669 50.1044L36.8232 49.7909ZM38.3978 52.244C38.173 52.1916 37.9559 52.1217 37.7477 52.0346C36.9249 51.6905 36.5058 50.7708 36.7859 49.9241C36.7995 49.883 36.8121 49.8387 36.8232 49.7909L38.1669 50.1044"
                fill="white"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M31.2502 24.1853C32.3483 19.4786 39.0489 19.4786 40.147 24.1853C40.3267 24.9552 41.2095 25.3209 41.8809 24.9035C45.9856 22.3519 50.7236 27.0899 48.172 31.1945C47.7546 31.8659 48.1202 32.7488 48.8902 32.9284C53.5969 34.0266 53.5969 40.7271 48.8902 41.8252C48.1202 42.0049 47.7546 42.8877 48.172 43.5592C50.7236 47.6638 45.9856 52.4018 41.8809 49.8502C41.2095 49.4328 40.3267 49.7985 40.147 50.5684C39.0489 55.2751 32.3483 55.2751 31.2502 50.5684C31.0706 49.7985 30.1877 49.4328 29.5163 49.8502C25.4117 52.4018 20.6736 47.6638 23.2253 43.5592C23.6427 42.8877 23.277 42.0049 22.5071 41.8252C17.8004 40.7271 17.8004 34.0266 22.5071 32.9284C23.277 32.7488 23.6427 31.8659 23.2253 31.1945C20.6736 27.0899 25.4117 22.3519 29.5163 24.9035C30.1877 25.3209 31.0706 24.9552 31.2502 24.1853ZM36.823 24.9608C36.5454 23.7712 34.8518 23.7712 34.5743 24.9608C33.8636 28.0069 30.3707 29.4537 27.7142 27.8023C26.6767 27.1574 25.4792 28.355 26.1241 29.3924C27.7755 32.0489 26.3287 35.5418 23.2826 36.2525C22.093 36.53 22.093 38.2236 23.2826 38.5012C26.3287 39.2119 27.7755 42.7048 26.1241 45.3612C25.4792 46.3987 26.6767 47.5963 27.7142 46.9513C30.3707 45.3 33.8636 46.7468 34.5743 49.7928C34.8518 50.9825 36.5454 50.9825 36.823 49.7929C37.5337 46.7468 41.0266 45.3 43.683 46.9513C44.7205 47.5963 45.9181 46.3987 45.2731 45.3612C43.6217 42.7048 45.0685 39.2119 48.1146 38.5012C49.3043 38.2236 49.3043 36.53 48.1146 36.2525C45.0685 35.5418 43.6217 32.0489 45.2731 29.3924C45.9181 28.355 44.7205 27.1574 43.683 27.8023C41.0266 29.4537 37.5337 28.0069 36.823 24.9608Z"
                fill="white"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M35.6994 34.8166C34.2855 34.8166 33.1394 35.9628 33.1394 37.3766C33.1394 38.7905 34.2855 39.9366 35.6994 39.9366C37.1132 39.9366 38.2594 38.7905 38.2594 37.3766C38.2594 35.9628 37.1132 34.8166 35.6994 34.8166ZM29.7261 37.3766C29.7261 34.0777 32.4004 31.4033 35.6994 31.4033C38.9983 31.4033 41.6727 34.0777 41.6727 37.3766C41.6727 40.6756 38.9983 43.3499 35.6994 43.3499C32.4004 43.3499 29.7261 40.6756 29.7261 37.3766Z"
                fill="white"
              />
            </svg>
          </div>
          <div class="hero--reasons--reason--text">
            <h5>Free resources for you.</h5>
            <p>
              Unlimited access to on-demand mentors to schedule as many calls as
              you like with our ‘on-demand’ design mentors who can provide
              additional feedback & insights.
            </p>
          </div>
        </div>
        <div class="hero--reasons--reason">
          <div class="hero--reasons--reason--image">
            <svg
              width="78"
              height="79"
              viewBox="0 0 78 79"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.956543 24.6539C0.956543 3.08174 4.03828 0 25.6104 0H53.3461C74.9183 0 78 3.08174 78 24.6539V52.3895C78 73.9617 74.9183 77.0435 53.3461 77.0435H25.6104C4.03828 77.0435 0.956543 73.9617 0.956543 52.3895V24.6539Z"
                fill="#8F3D55"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M22.8999 20.234C22.8999 19.2914 23.664 18.5273 24.6066 18.5273H55.3264C56.269 18.5273 57.0331 19.2914 57.0331 20.234V57.7805C57.0331 58.7231 56.269 59.4872 55.3264 59.4872H24.6066C23.664 59.4872 22.8999 58.7231 22.8999 57.7805V20.234ZM26.3132 21.9407V56.0738H53.6198V21.9407H26.3132Z"
                fill="white"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M29.7261 20.234C29.7261 19.2914 30.4902 18.5273 31.4327 18.5273H48.4993C49.4419 18.5273 50.206 19.2914 50.206 20.234V27.0606C50.206 28.0032 49.4419 28.7673 48.4993 28.7673H31.4327C30.4902 28.7673 29.7261 28.0032 29.7261 27.0606V20.234ZM33.1394 21.9407V25.354H46.7927V21.9407H33.1394Z"
                fill="white"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M28.0195 33.8873C28.0195 32.9448 28.8424 32.1807 29.8575 32.1807H50.0748C51.0899 32.1807 51.9128 32.9448 51.9128 33.8873C51.9128 34.8299 51.0899 35.594 50.0748 35.594H29.8575C28.8424 35.594 28.0195 34.8299 28.0195 33.8873Z"
                fill="white"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M43.3789 45.8346C43.3789 44.892 44.143 44.1279 45.0856 44.1279L50.2055 44.1279C51.1481 44.1279 51.9122 44.892 51.9122 45.8346C51.9122 46.7772 51.1481 47.5412 50.2055 47.5412L45.0856 47.5412C44.143 47.5412 43.3789 46.7772 43.3789 45.8346Z"
                fill="white"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M43.3789 40.7154C43.3789 39.7729 44.143 39.0088 45.0856 39.0088L50.2055 39.0088C51.1481 39.0088 51.9122 39.7729 51.9122 40.7154C51.9122 41.658 51.1481 42.4221 50.2055 42.4221L45.0856 42.4221C44.143 42.4221 43.3789 41.658 43.3789 40.7154Z"
                fill="white"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M43.3789 50.9547C43.3789 50.0121 44.143 49.248 45.0856 49.248L50.2055 49.248C51.1481 49.248 51.9122 50.0121 51.9122 50.9547C51.9122 51.8973 51.1481 52.6614 50.2055 52.6614L45.0856 52.6614C44.143 52.6614 43.3789 51.8973 43.3789 50.9547Z"
                fill="white"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M28.0195 39.0074C28.0195 38.0649 28.7836 37.3008 29.7262 37.3008H39.9661C40.9087 37.3008 41.6728 38.0649 41.6728 39.0074V52.6607C41.6728 53.6033 40.9087 54.3674 39.9661 54.3674H29.7262C28.7836 54.3674 28.0195 53.6033 28.0195 52.6607V39.0074ZM31.4328 40.7141V50.9541H38.2595V40.7141H31.4328Z"
                fill="white"
              />
            </svg>
          </div>
          <div class="hero--reasons--reason--text">
            <h5>Get a CV profile you share.</h5>
            <p>
              Unlimited access to on-demand mentors to schedule as many calls as
              you like with our ‘on-demand’ design mentors who can provide
              additional feedback & insights.
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="hero--bg--behind">
      <svg width="610" height="374" viewBox="0 0 610 374" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M-30.9918 175.926C9.44586 120.729 96.3752 125.188 159.608 93.4697C216.012 65.1761 254.751 -3.62947 318.437 0.646157C382.136 4.9227 412.158 74.0905 459.482 113.602C504.103 150.857 563.361 174.17 587.463 225.259C613.917 281.335 616.236 345.841 596.801 404.682C576.252 466.894 542.111 535.437 477.016 559.646C413.196 583.38 349.356 522.862 280.811 522.197C206.165 521.474 132.51 584.775 65.0186 555.652C-3.75631 525.976 -32.5718 448.125 -49.9271 379.484C-67.0684 311.689 -73.4137 233.832 -30.9918 175.926Z" fill="#F4D2DC"/>
</svg>
<svg width="540" height="382" viewBox="0 0 540 382" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M323.513 2.95045C388.32 -9.32325 443.309 30.2394 498.224 55.5246C545.683 77.3764 590.761 102.318 622.013 140.392C652.116 177.067 660.175 223.599 673.165 268.655C687.704 319.083 716.774 367.63 702.937 421.082C688.415 477.183 650.934 534.223 595.727 567.796C541.673 600.668 474.394 596.548 412.293 597.83C360.088 598.908 311.298 589.604 263.915 574.647C218.312 560.252 180.578 536.687 141.622 512.391C92.3095 481.635 20.7309 465.451 4.32206 412.741C-11.9336 360.522 30.8732 302.656 60.0105 250.229C87.3391 201.057 125.088 158.414 168.106 118.045C215.308 73.7488 258.722 15.221 323.513 2.95045Z" fill="#EAD0D8"/>
</svg>
</div> -->
  </section>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "@/styles/_mixins.scss";
@import "@/styles/_variables.scss";
@import "@/styles/_typography.scss";

.hero {
  background: #f9f2ee;
}
.hero--box {
  padding: 5rem 7% 3rem 7%;
  text-align: center;
  h2 {
    padding: 0 0rem;
    @include heading2 {
      color: $secondary-80;
      font-family: $karla;
    }
  }
}
.hero--reasons {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(543px, 1fr));
  gap: 3rem;
  place-items: center;
  margin-top: 2rem;
  .hero--reasons--reason {
    display: flex;
    align-items: center;
    padding: 3%;
    gap: 2rem;
    margin: 0 auto 1rem auto;
    max-width: 100vw;
    width: 543px;
    height: 198px;
    background: #ffffff;
    border-radius: 10px;
    text-align: left;
    h5 {
      margin-bottom: 0.5rem;
      @include sub-heading-bold {
        color: $secondary-80;
        font-family: $karla;
      }
    }
    @include caption {
      color: $black-100;
      font-family: $karla;
    }
  }
}
@include md {
  .hero--box {
  padding: 2rem 5% 3rem 5%;
  h2 {
    @include heading2 {
      font-size: 1.5rem;
    }
  }
}
.hero--reasons {
  margin-top: 1rem;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  .hero--reasons--reason {
    width: 90%;
    h5 {
      margin-bottom: 0.5rem;
      @include sub-heading-bold {
        font-size: 1.3rem
      }
    }
    p {
    @include caption {
      font-size: 0.9rem;
    }
    }
  }
}
}
@include xs {
  .hero--box {
    h2 {
    @include heading2 {
      font-size: 1.35rem;
    }
    }
  }
  .hero--reasons {
  .hero--reasons--reason {
    flex-direction: column;
    text-align: center;
    width: 90%;
    height: auto;
    h5 {
      margin-bottom: 0.5rem;
      @include sub-heading-bold {
        font-size: 1.5rem
      }
    }
    @include caption {
      font-size: 1rem;
    }
  }
}
}
</style>